export const config = {
  title: "Stines and Company | Rutherfordton, NC",
  meta: {
    description:
      "Stines and Company is a premier excavating contractor in Rutherfordton, NC. Experienced site contractors delivering top-notch results for land clearing, grading, site preparation, and excavation projects.",
    keywords: [
      "Stines and Company",
      "Excavating Contractor Rutherfordton NC",
      "Land Clearing North Carolina",
      "Site Preparation",
      "Grading Services",
      "Excavation Rutherfordton",
      "Demolition Contractor",
      "Driveway Installation",
      "Foundation Excavation",
      "Site Contractor NC"
    ],
    author: "Stines and Company",
    canonicalUrl: "https://stinesandcompanyllc.com/",
  },
  sections: {
    header: {
      businessName: "Stines and Company",
    },
    sectionB: {
      heroTitle: "Premier Excavating Contractor Services",
      heroSubtitle: "Experienced Site Contractors Delivering Top-Notch Results in Rutherfordton, NC",
      learnAboutText: "Request a Quote",
      phoneNumber: "8289894950",
      phoneLabel: "(828) 989-4950",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/981339754/photo/silhouette-of-engineer-and-construction-team-working-at-site-over-blurred-background-sunset.jpg?s=612x612&w=0&k=20&c=ACQLq17lMGeOpqp51hfR5AmK_yk_X_AIngfeq1frujk=",
      cardData: [
        {
          title: "Site Preparation",
          description:
            "Professional site preparation and land clearing services to get your project started right.",
        },
        {
          title: "Excavation & Grading",
          description:
            "Expert excavation and grading services for residential and commercial construction projects.",
        },
        {
          title: "Land Clearing",
          description:
            "Comprehensive land clearing solutions including tree removal, brush clearing, and site cleanup.",
        },
      ],
      description:
        "Stines and Company is a premier excavating contractor based in Rutherfordton, North Carolina. We are experienced site contractors committed to delivering top-notch results for all your excavation and site development needs.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive excavating and site contractor services for residential and commercial projects throughout Rutherfordton and surrounding areas.",
      cards: [
        {
          title: "Site Preparation & Development",
          description:
            "Complete site preparation services including clearing, grading, and preparing your property for construction projects of any size.",
          imageSrc: "https://media.istockphoto.com/id/2192844459/photo/prepared-for-building-works-construction-site-with-many-equipment-in-american-rural-area.jpg?s=612x612&w=0&k=20&c=OAU2wZYEN-X69xLuox7ATbsYS24Zyfc0v2pIT-QIxtM=",
          imageAlt: "Site Preparation Services",
        },
        {
          title: "Excavation & Grading",
          description:
            "Professional excavation and grading services for foundations, basements, driveways, and roads using modern equipment and techniques.",
          imageSrc: "https://media.istockphoto.com/id/2158258671/photo/crawler-excavator-earthmoving-equipment-land-clearing-foundation-digging-construction-work.jpg?s=612x612&w=0&k=20&c=r7M57Ob3UXfwaUZLREc0DPIJiUBVMpP94tTi71ZnB1c=",
          imageAlt: "Excavation and Grading",
        },
        {
          title: "Land Clearing",
          description:
            "Efficient land clearing services including tree removal, brush clearing, stump removal, and site cleanup for development projects.",
          imageSrc: "https://media.istockphoto.com/id/2155781703/photo/graded-dirt-lots-ready-for-new-house-and-neighborhood-construction.jpg?s=612x612&w=0&k=20&c=41tQwP8CFfsS8X0rSBSGnzrw1NRVjJq14r04XgioVMQ=",
          imageAlt: "Land Clearing Services",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Foundation Excavation",
        "Driveway Installation",
        "Demolition Services",
        "Drainage Solutions",
        "Erosion Control",
      ],
    },
    sectionD: {
      aboutTitle: "About Stines and Company",
      aboutImage: {
        src: "https://landing-page-app-hero-images.s3.amazonaws.com/media/9856f2dc-4870-4c59-bc3a-37c9d2792142.jpg",
        alt: "Stines and Company Excavating",
      },
      aboutText: [
        "Stines and Company is a premier excavating contractor serving Rutherfordton, North Carolina and the surrounding areas. As experienced site contractors, we bring expertise, reliability, and dedication to every project we undertake.",
        "Whether you need site preparation for a new home, land clearing for development, or professional excavation and grading services, our team has the knowledge and equipment to deliver top-notch results. We pride ourselves on completing projects on time, within budget, and to the highest standards of quality.",
      ],
    },
    sectionE: {
      profileImage: "https://d3p2r6ofnvoe67.cloudfront.net/fit-in/448x448/filters:strip_exif()/filters:no_upscale()/filters:format(webp)/media/d55e5b97-e778-4b47-bda0-c8f80ad4236b.png",
      profileAlt: "Stines and Company LLC",
      businessName: "Stines and Company",
      contact: {
        phone: "8289894950",
        phoneLabel: "(828) 989-4950",
        email: "stinesandcompanyllc@gmail.com",
        website: "https://stinesandcompanyllc.com/",
        address: "Rutherfordton, NC",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Rutherfordton, NC",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52234.8!2d-81.9568!3d35.3694!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88510e8e8e8e8e8e%3A0x8e8e8e8e8e8e8e8e!2sRutherfordton%2C%20NC!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;